var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "leo-operator-assistant" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.panelOpen,
            expression: "panelOpen"
          }
        ],
        ref: "panel",
        staticClass: "leo-assistant-float-panel",
        class: { "leo-assistant-float-panel--chat": _vm.mode === "chat" },
        style: _vm.panelStyle
      },
      [
        _c(
          "header",
          {
            staticClass: "leo-assistant-float-head",
            on: {
              mousedown: function($event) {
                $event.preventDefault()
                return _vm.onPanelDragStart.apply(null, arguments)
              }
            }
          },
          [
            _c("span", { staticClass: "leo-assistant-float-title" }, [
              _vm._v("Leo SOC助手")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "leo-assistant-float-actions" }, [
              _c(
                "button",
                {
                  staticClass:
                    "leo-assistant-float-iconbtn leo-assistant-float-iconbtn--close",
                  attrs: {
                    type: "button",
                    title: "关闭",
                    "aria-label": "close"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "assistant-shell",
            class: { "assistant-shell--chat": _vm.mode === "chat" }
          },
          [
            (_vm.pageFunctionZh ||
              (_vm.pageStepsZh && _vm.pageStepsZh.length)) &&
            _vm.mode !== "chat"
              ? _c(
                  "section",
                  {
                    staticClass: "assistant-card",
                    attrs: { "data-testid": "soc-assistant-page-help" }
                  },
                  [
                    _c("header", { staticClass: "assistant-card__head" }, [
                      _c(
                        "div",
                        { staticClass: "assistant-card__title-row" },
                        [
                          _c("h3", { staticClass: "assistant-card__title" }, [
                            _vm._v(_vm._s(_vm.pageHelpTitleZh || "本页说明"))
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "mini",
                                type: "info",
                                effect: "plain"
                              }
                            },
                            [_vm._v("页面指引")]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "assistant-card__body" }, [
                      _vm.pageFunctionZh
                        ? _c("p", { staticClass: "assistant-page-help__fn" }, [
                            _vm._v(_vm._s(_vm.pageFunctionZh))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pageStepsZh && _vm.pageStepsZh.length
                        ? _c(
                            "ol",
                            { staticClass: "assistant-page-help__steps" },
                            _vm._l(_vm.pageStepsZh, function(s, i) {
                              return _c("li", { key: i }, [_vm._v(_vm._s(s))])
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  ]
                )
              : _vm.mode === "chat" &&
                (_vm.pageHelpTitleZh || _vm.pageFunctionZh)
              ? _c(
                  "p",
                  {
                    staticClass:
                      "assistant-page-preface assistant-page-preface--compact"
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.pageHelpTitleZh || "本页") +
                        _vm._s(
                          _vm.pageFunctionZh ? " · " + _vm.pageFunctionZh : ""
                        ) +
                        "\n      "
                    )
                  ]
                )
              : _vm.pagePreface && _vm.mode !== "chat"
              ? _c("p", { staticClass: "assistant-page-preface" }, [
                  _vm._v(_vm._s(_vm.pagePreface))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "assistant-mode-bar", attrs: { role: "tablist" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.mode,
                      callback: function($$v) {
                        _vm.mode = $$v
                      },
                      expression: "mode"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "manual" } }, [
                      _vm._v(_vm._s(_vm.$t("route.socAssistantTabManual")))
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "guide" } }, [
                      _vm._v(_vm._s(_vm.$t("route.socAssistantTabGuide")))
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "chat" } }, [
                      _vm._v(_vm._s(_vm.$t("route.socAssistantTabChat")))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.mode === "chat"
              ? _c(
                  "section",
                  { staticClass: "assistant-card assistant-card--chat" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "assistant-card__body assistant-card__body--chat"
                      },
                      [
                        _c("iframe", {
                          key: _vm.chatFrameKey,
                          staticClass: "assistant-chat-iframe",
                          attrs: {
                            src: _vm.chatFrameSrc,
                            title: "Leo chat",
                            "data-testid": "soc-assistant-leo-chat"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm.mode === "guide"
              ? _c(
                  "section",
                  { staticClass: "assistant-card assistant-card--nest" },
                  [_c("soc-smart-guide-panel")],
                  1
                )
              : _c("div", { staticClass: "assistant-manual" }, [
                  _c("section", { staticClass: "assistant-card" }, [
                    _c("header", { staticClass: "assistant-card__head" }, [
                      _c(
                        "div",
                        { staticClass: "assistant-card__title-row" },
                        [
                          _c("h3", { staticClass: "assistant-card__title" }, [
                            _vm._v("快捷问法")
                          ]),
                          _vm._v(" "),
                          _vm.topicScope
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "assistant-scope-tag",
                                  attrs: {
                                    size: "mini",
                                    type: _vm.topicScopeTagType
                                  }
                                },
                                [_vm._v(_vm._s(_vm.topicScopeLabel))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "assistant-card__body" }, [
                      _c("p", { staticClass: "muted assistant-hint" }, [
                        _vm._v(
                          "\n              已感知当前页面；快捷问法仅显示本页相关。也可直接下方提问。\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.quickTopics.length
                        ? _c(
                            "div",
                            { staticClass: "assistant-topics" },
                            _vm._l(_vm.quickTopics, function(t) {
                              return _c(
                                "el-button",
                                {
                                  key: t.id,
                                  attrs: {
                                    size: "mini",
                                    plain: "",
                                    loading:
                                      _vm.loading && _vm.question === t.question
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.askQuick(t.question)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(t.labelZh))]
                              )
                            }),
                            1
                          )
                        : _vm.topicScope === "empty"
                        ? _c(
                            "p",
                            { staticClass: "assistant-empty-topics muted" },
                            [
                              _vm._v(
                                "\n              本页暂无快捷问法，请直接在下方输入本页相关问题。\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("section", { staticClass: "assistant-card" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "assistant-card__body" },
                      [
                        _vm.clarifyOptions.length
                          ? _c("div", { staticClass: "assistant-clarify" }, [
                              _c(
                                "p",
                                { staticClass: "assistant-clarify-prompt" },
                                [_vm._v(_vm._s(_vm.clarifyPrompt))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "assistant-clarify-opts" },
                                _vm._l(_vm.clarifyOptions, function(opt, idx) {
                                  return _c(
                                    "el-button",
                                    {
                                      key: idx,
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.askClarifyOption(opt)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(opt.label))]
                                  )
                                }),
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            resize: "none",
                            placeholder:
                              "输入问题，例如：这页设备列表怎么搜 IMIE？"
                          },
                          model: {
                            value: _vm.question,
                            callback: function($$v) {
                              _vm.question = $$v
                            },
                            expression: "question"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "assistant-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  loading: _vm.loading
                                },
                                on: { click: _vm.ask }
                              },
                              [_vm._v("提问")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "small",
                                  plain: "",
                                  disabled: !_vm.answer || _vm.loading
                                },
                                on: { click: _vm.onWrongAnswer }
                              },
                              [_vm._v("回答不对")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.answer
                    ? _c("section", { staticClass: "assistant-card" }, [
                        _c("header", { staticClass: "assistant-card__head" }, [
                          _c(
                            "div",
                            { staticClass: "assistant-card__title-row" },
                            [
                              _c(
                                "h3",
                                { staticClass: "assistant-card__title" },
                                [_vm._v("回答")]
                              ),
                              _vm._v(" "),
                              _vm.answerLayerZh
                                ? _c(
                                    "el-tag",
                                    {
                                      staticClass: "assistant-layer-tag",
                                      attrs: {
                                        size: "mini",
                                        type: _vm.answerLayerTagType
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.answerLayerZh))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "assistant-card__body" }, [
                          _c("pre", { staticClass: "assistant-answer-body" }, [
                            _vm._v(_vm._s(_vm.answer))
                          ]),
                          _vm._v(" "),
                          _vm.disclaimer
                            ? _c(
                                "p",
                                { staticClass: "muted assistant-disclaimer" },
                                [_vm._v(_vm._s(_vm.disclaimer))]
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ])
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "leo-assistant-float-resize",
          attrs: { title: "拖曳右下角调整大小", "aria-hidden": "true" },
          on: {
            mousedown: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onPanelResizeStart.apply(null, arguments)
            }
          }
        })
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "assistant-card__head" }, [
      _c("div", { staticClass: "assistant-card__title-row" }, [
        _c("h3", { staticClass: "assistant-card__title" }, [_vm._v("提问")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-477408b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477408b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/LeoTrainingOperatorAssistant.vue
// module id = null
// module chunks = 